import _ from 'lodash'
import { user } from '../utils'
import { replaceTableUserInfo } from './dataTable'
const { getMappedUsers, getUserForeignKeys } = user

export const initAuditTable = (tableType, providers) => {
  const fetchTable = id => {
    return async (dispatch, getState) => {
      const response = await providers.getTableValues(null, id)
      dispatch({
        type: `GET_${tableType}`,
        history: response.histories,
      })

      /**
       * If we have an user search provider
       * look for their data and store it in redux
       */
      if (providers.getUsers) {
        const userIdKeys = getUserForeignKeys(getState(), tableType)
        const userIds = _.uniq(
          userIdKeys.reduce((userIdList, nextUserKey) => {
            return [
              ...userIdList,
              ...response.histories.map(entry => entry[nextUserKey]),
            ]
          }, [])
        )

        if (!_.isEmpty(userIds)) {
          const searchResponse = await providers.getUsers(null, userIds)
          const usersList = searchResponse.content
          const mappedUsers = getMappedUsers(usersList)
          dispatch(replaceTableUserInfo(mappedUsers, tableType, userIdKeys))
        }
      }
    }
  }
  return {
    fetchTable,
  }
}
